<bl-modal-content #content
  [title]="'結果入力'"
  [footerButtonType]="ModalButtonType.Custom"
>
  <div body class="contact-result" [class.cursor-wait]="_isGettingUrl">
    <div class="contact-result__summary">
      <div class="summary">
        <div class="summary__title">未実施<span class="summary__count">{{ _statusCount?.notImplemented }}</span>件</div>
        <div class="summary__title">実施済<span class="summary__count">{{ _statusCount?.implemented }}</span>件</div>
      </div>
      <div class="status">
        <span class="semicolon-title">状況</span>{{ status }}
      </div>
    </div>
    <div class="contact-result__form">
      <table class="table table-bordered table-contact">
        <tbody>
          <tr>
            <th class="label-tag-required">実施担当</th>
            <td colspan="3">
              <div class="table-contact__row">
                <div class="table-contact__column">
                  <div class="input-group">
                    <bl-code-input
                      [value]="_entity?.contactEmployeeName"
                      [placeholder]="'右のガイドからお選びください'"
                      [resource]="employeeResource"
                      [option]="{ valueProperty: 'employeeName', enableBlank: true }"
                      [validator]="_blFormGroup?.validatorGroup[DEFINE.RULE_KEY.EMPLOYEE_NAME]"
                      (beginSearchEvent)="onBeginSearchEmployee($event)"
                      (afterSearchEvent)="onAfterSearchContactEmployee($event)"
                    ></bl-code-input>
                    <span class="input-group-btn">
                      <button #contactEmployeeGuideBtn class="btn btn-default"
                        (click)="onShowContactEmployeeGuide(contactEmployeeGuideBtn)"
                      >
                        <span class="icon-icon_guide"></span>
                      </button>
                    </span>
                  </div>
                </div>
                <div class="table-contact__column table-contact__column--actions">
                  <button *shareServiceIf="ContractConst.SERVICEID_OPT_CMN_CUST_CAR_DMSEND" #sendSingleMessageBtn class="btn btn-success" [disabled]="_targetVehicleMgtNumber === 0 || _isConnecting" (click)="onShowSendSingleMessageModal(sendSingleMessageBtn)">ご連絡</button>
                  <button #receptionBtn class="btn btn-success" [disabled]="_targetVehicleMgtNumber === 0 || _isConnecting" (click)="onOpenWindow(RoutePath.RECEPTION, receptionBtn)">受付</button>
                  <button *shareServiceIf="ContractConst.SERVICEID_OPT_CMN_RESERVE_MGT" class="btn btn-default" [disabled]="_isConnecting" (click)="onOpenWindow(RoutePath.RESERVE)">予約ｶﾚﾝﾀﾞｰ</button>
                  <button class="btn btn-default" [disabled]="_isConnecting" (click)="onOpenWindow(RoutePath.CUSTOMER)">顧客編集</button>
                  <button class="btn btn-default" [disabled]="_targetVehicleMgtNumber === 0 || _isConnecting" (click)="onOpenWindow(RoutePath.VEHICLE)">車両編集</button>
                  <button class="btn btn-default" [disabled]="_isConnecting" (click)="onOpenWindow()">伝票発行</button>
                  <button class="btn btn-default" [disabled]="_targetVehicleMgtNumber === 0 || _isConnecting" (click)="onOpenWindow(RoutePath.SLIP_HISTORY)">伝票履歴</button>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>顧客情報</th>
            <td colspan="3">
              <div class="table-contact__group">
                <div class="table-contact__row">
                  <div class="table-contact__column">
                    <span class="semicolon-title semicolon-title--bold">顧客区分</span>
                    <span class="table-contact__priv-corp-div">{{ _selectedContact?.gridData?.privCorpDivEnumName }}</span>
                    <span class="semicolon-title semicolon-title--bold">顧客名</span>
                    {{ _selectedContact?.gridData?.customerName }}&nbsp;{{ _selectedContact?.gridData?.customerNameKana ? '(' + _selectedContact?.gridData?.customerNameKana + ')' : '' }}
                  </div>
                  <div class="table-contact__column table-contact__column--sm">
                    <span class="semicolon-title semicolon-title--bold">ランク</span>
                    {{ _selectedContact?.gridData?.customerRankName }}
                  </div>
                  <div class="table-contact__column table-contact__column--sm">
                    <span class="semicolon-title semicolon-title--bold">顧客担当</span>
                    {{ _selectedContact?.gridData?.managerName }}
                  </div>
                </div>
                <div class="table-contact__row">
                  <div class="table-contact__column table-contact__column--separator"></div>
                  <div class="table-contact__column table-contact__column--sm table-contact__column--separator"></div>
                  <div class="table-contact__column table-contact__column--sm table-contact__column--separator"></div>
                </div>
                <div class="table-contact__row">
                  <div class="table-contact__column">
                    <span class="semicolon-title semicolon-title--bold">車両</span>
                    {{ _selectedContact?.gridData?.vehicleModelFullWName }}&nbsp;{{ _selectedContact?.gridData?.displayNumPlate }}
                  </div>
                  <div class="table-contact__column table-contact__column--sm">
                    <span class="semicolon-title semicolon-title--bold">連絡先</span>
                    {{ _selectedContact?.gridData?.contactInformation ? contactTypeName: '' }}{{ _selectedContact?.gridData?.contactInformation }}
                  </div>
                  <div class="table-contact__column table-contact__column--sm">
                    <span class="semicolon-title semicolon-title--bold">連絡可能時間帯</span>
                    {{ _selectedContact?.gridData?.contactEnableTimeName }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th>実施内容</th>
            <td>{{ _selectedContact?.gridData?.executeItem }}</td>
            <th>実施予定日時</th>
            <td>
              {{ _selectedContact?.gridData?.scheduleDate }}
              {{ _selectedContact?.gridData?.scheduleTime }}
            </td>
          </tr>
          <tr>
            <th class="label-tag-required">実施結果</th>
            <td colspan="3">
              <bl-radio-group #contactExecuteResult
                [value]="_entity?.contactExecuteResultCode"
                [items]="_contactExecuteResultList"
                [groupType]="'inline'"
                [option]="{ valueProperty: 'contactExecuteResultCode', labelProperty: 'contactExecuteResult' }"
                [validator]="_blFormGroup?.validatorGroup[DEFINE.RULE_KEY.EXECUTE_RESULT_CODE]"
                (changeEvent)="onChangeExecuteResultCode($event)"
              ></bl-radio-group>
            </td>
          </tr>
          <!-- 実施結果区分が「失注」の場合のみ表示 -->
          <tr *ngIf="_lostOrderFlg">
            <th class="label-tag-required">失注理由</th>
            <td colspan="3">
              <bl-radio-group
                [value]="_entity?.contactLostReasonCode"
                [items]="_contactLostReasonList"
                [groupType]="'inline'"
                [option]="{ valueProperty: 'contactLostReasonCode', labelProperty: 'contactLostReason' }"
                [validator]="_blFormGroup?.validatorGroup[DEFINE.RULE_KEY.LOST_REASON_CODE]"
                (changeEvent)="onChangeLostReasonCode($event)"
              ></bl-radio-group>
            </td>
          </tr>
          <tr>
            <ng-container *ngIf="!_selectedContact?.contactHistory">
              <th [class.label-tag-required]="_reContactCheckFlg">再連絡</th>
              <td class="table-contact__recontact">
                <div class="table-contact__group">
                  <div class="table-contact__row">
                    <div class="table-contact__column table-contact__column--recontact">
                      <bl-checkbox
                        [checked]="_reContactCheckFlg"
                        [label]="'再連絡する'"
                        [inline]="true"
                        (changeEvent)="onChangeReContactCheckFlg($event.target.checked)"
                      ></bl-checkbox>
                    </div>
                    <div class="table-contact__column">
                      <div class="input-group">
                        <bl-code-input
                          [value]="_entity?.reContactEmployeeName"
                          [placeholder]="'右のガイドからお選びください'"
                          [resource]="employeeResource"
                          [option]="{ valueProperty: 'employeeName', enableBlank: true }"
                          [disabled]="_reContactCheckFlg === false"
                          [validator]="_blFormGroup?.validatorGroup[DEFINE.RULE_KEY.RE_EMPLOYEE_NAME]"
                          (beginSearchEvent)="onBeginSearchEmployee($event)"
                          (afterSearchEvent)="onAfterSearchEmployee($event)"
                        ></bl-code-input>
                        <span class="input-group-btn">
                          <button #employeeGuideBtn class="btn btn-default"
                            [disabled]="_reContactCheckFlg === false"
                            (click)="onShowEmployeeGuide(employeeGuideBtn)"
                          >
                            <span class="icon-icon_guide"></span>
                          </button>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="table-contact__row">
                    <bl-datetime
                      [value]="_entity?.reContactImplScheduleDate"
                      [disabled]="_reContactCheckFlg === false"
                      [validator]="_blFormGroup?.validatorGroup[DEFINE.RULE_KEY.RE_SCHEDULE_DATE]"
                      (changeEvent)="onChangeReContactDateTime($event)"
                    ></bl-datetime>
                  </div>
                </div>
              </td>
            </ng-container>
            <th>
              メモ<button #memoGuideBtn class="btn btn-default" (click)="onShowContactMemoGuide(memoGuideBtn)">定型文</button>
            </th>
            <td [attr.colspan]="_selectedContact?.contactHistory ? 3 : 0">
              <bl-textarea
                [(value)]="_entity && _entity.contactComment"
                [rows]="3"
                [validator]="_blFormGroup?.validatorGroup[DEFINE.RULE_KEY.COMMENT]"
              ></bl-textarea>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="contact-result__history">
      <div class="section-title">最近のお付き合い</div>
      <table class="table table-bordered table-relation" [class.table-relation--empty]="_scheduleHistoryList == null || _scheduleHistoryList.length === 0">
        <tbody>
          <tr>
            <th class="datetime">日時</th>
            <th class="person">実施担当</th>
            <th>実施内容</th>
            <th class="result">実施結果</th>
            <th class="reason">失注理由</th>
          </tr>
          <tr>
            <th colspan="5">メモ</th>
          </tr>
          <tr *ngFor="let scheduleHistory of _scheduleHistoryList">
            <td colspan="5">
              <div class="table-relation__group">
                <div class="table-relation__column table-relation__column--mark">
                  <span [style.background-color]="scheduleHistory.itemServiceColor" class="icon-circle"></span>
                </div>
                <div class="table-relation__column table-relation__column--mark">
                  <span *ngIf="scheduleHistory.isHistory">済</span>
                </div>
                <div class="table-relation__column">
                  <div class="table-relation__row">
                    <div class="table-relation__item datetime">
                      {{ scheduleHistory.dateTime | blDateFormat }}
                      <ng-container *ngIf="scheduleHistory.showTimeFlg">
                        {{ scheduleHistory.dateTime | blDateFormat:'lt' }}
                      </ng-container>
                    </div>
                    <div class="table-relation__item person">{{ scheduleHistory.executeEmployeeName }}</div>
                    <div class="table-relation__item">{{ scheduleHistory.executeItem }}</div>
                    <div class="table-relation__item result">
                      <ng-container *ngIf="scheduleHistory.contactHistory && !scheduleHistory.customerChangedFlag">
                        <button #transitionBtn class="btn btn-link execute-result-link"
                          (click)="onOpenExecuteResult(scheduleHistory.contactHistory, transitionBtn)"
                        >{{ scheduleHistory.executeResult }}</button>
                      </ng-container>
                      <ng-container *ngIf="!scheduleHistory.contactHistory || scheduleHistory.customerChangedFlag">
                        <span class="execute-result-text">{{ scheduleHistory.executeResult }}</span>
                      </ng-container>
                    </div>
                    <div class="table-relation__item reason">{{ scheduleHistory.lostReason }}</div>
                  </div>
                  <div class="table-relation__row">
                    <div class="table-relation__item">
                      <span class="semicolon-title">メモ&nbsp;<span class="icon-icon_memo"></span></span>
                      {{ scheduleHistory.contactComment }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-container *ngIf="_scheduleHistoryList == null || _scheduleHistoryList.length === 0">
        <div class="empty-container">
          <div *ngIf="_scheduleHistoryList == null" class="empty-container__loading"><span class="spin"></span></div>
          <div *ngIf="_scheduleHistoryList" class="empty-container__message">最近のお付き合いはありません</div>
        </div>
      </ng-container>
    </div>
  </div>

  <div footer>
    <button #cancelBtn class="btn btn-default" [disabled]="content.isLoading" (click)="content.cancel()">キャンセル</button>
    <button class="btn btn-default"
      [disabled]="_selectedIndex === undefined || _selectedIndex === 0 || content.isLoading"
      (click)="onMove(false)"
    >前へ</button>
    <button class="btn btn-default"
    [disabled]="_selectedIndex === undefined || _selectedIndex === (data?.contactList.length - 1) || content.isLoading"
    (click)="onMove(true)"
    >次へ</button>
    <button class="btn btn-default" [disabled]="!_selectedContact?.contactHistory || content.isLoading"
      (click)="onCancel()">結果取消</button>
    <button #okBtn class="btn btn-success" [disabled]="content.isLoading" (click)="onDone()">登録</button>
  </div>

</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/result-form-modal/result-form-modal.component.html